import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Button';
import ConfirmationDialog from '../../ConfirmationDialog/ConfirmationDialog';
import { CourseTimetableMappingDialogsComponentProps } from '../CourseMapping.interfaces';

export const CourseMappingDialogsComponent: FC<CourseTimetableMappingDialogsComponentProps> = (
  props,
) => {
  const { save, reset, disabled, hasError, changes = [] } = props;
  const { t } = useTranslation();
  const [openSave, setOpenSave] = useState<boolean>(false);
  const [openDiscard, setOpenDiscard] = useState<boolean>(false);

  const saveDialogContent = (
    <div className="flex flex-col gap-3">
      <span>
        {t('settings:courseimport:courseMappingComponent:changes_activation_delay_text', {
          defaultValue:
            'Die hier gespeicherten Änderungen werden nicht sofort übernommen. Es kann einige Minuten dauern, bis sie wirksam werden.',
        })}
      </span>
      {changes.length > 0 && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">
            {t('settings:courseimport:courseMappingComponent:changes_summary_title', {
              defaultValue: 'Folgende Änderungen werden übernommen:',
            })}
          </span>
          {changes.map((change) => {
            const courseName = `${t(
              `settings:courseimport:${change.timetableCourse.groupType}`,
            )}: ${change.timetableCourse.lessonName}`;
            const target = change.azureGroupName
              ? change.azureGroupName
              : t('settings:courseimport:courseMappingComponent:change_removed', {
                  defaultValue: 'Zuweisung entfernt',
                });
            return (
              <span key={change.timetableCourse.entityRevisionsId}>
                {`${courseName} → ${target}`}
              </span>
            );
          })}
        </div>
      )}
      <span>
        {t('do_you_want_to_save_changes', {
          defaultValue: 'Möchten Sie die Änderungen speichern?',
        })}
      </span>
    </div>
  );

  return (
    <>
      <div className="flex gap-2 items-center">
        <Button onClick={() => setOpenDiscard(true)} disabled={disabled}>
          {t('reset', { defaultValue: 'Zurücksetzen' })}
        </Button>
        <Button
          appearance="primary"
          onClick={() => setOpenSave(true)}
          disabled={hasError || disabled}
        >
          {t('save', { defaultValue: 'Speichern' })}
        </Button>
      </div>
      <ConfirmationDialog
        open={openSave}
        showCloseButton
        onConfirm={() => {
          save?.();
          setOpenSave(false);
        }}
        onCancel={() => setOpenSave(false)}
        headerText={t('save_changes', { defaultValue: 'Änderungen speichern' })}
        cancelButtonText={t('cancel', { defaultValue: 'Abbrechen' })}
        confirmButtonText={t('save', { defaultValue: 'Speichern' })}
        content={saveDialogContent}
      />
      <ConfirmationDialog
        open={openDiscard}
        showCloseButton
        onConfirm={() => {
          reset?.();
          setOpenDiscard(false);
        }}
        onCancel={() => setOpenDiscard(false)}
        headerText={t('reset_changes', { defaultValue: 'Änderungen zurücksetzen' })}
        cancelButtonText={t('cancel', { defaultValue: 'Abbrechen' })}
        confirmButtonText={t('reset', { defaultValue: 'Zurücksetzen' })}
        content={t('do_you_want_to_reset_changes', {
          defaultValue: 'Möchten Sie wirklich alle ungespeicherten Änderungen zurücksetzen?',
        })}
      />
    </>
  );
};
